// Set 17 "Space Gods" champion portrait URLs
// Pattern: https://raw.communitydragon.org/pbe/game/assets/characters/tft17_{id}/hud/tft17_{id}_square.tft_set17.png
const BASE = 'https://raw.communitydragon.org/pbe/game/assets/characters'

export const CHAMPION_IMAGES: Record<string, string> = {
  "Aatrox":           `${BASE}/tft17_aatrox/hud/tft17_aatrox_square.tft_set17.png`,
  "Akali":            `${BASE}/tft17_akali/hud/tft17_akali_square.tft_set17.png`,
  "Aurelion Sol":     `${BASE}/tft17_aurelionsol/hud/tft17_aurelionsol_square.tft_set17.png`,
  "Aurora":           `${BASE}/tft17_aurora/hud/tft17_aurora_square.tft_set17.png`,
  "Bard":             `${BASE}/tft17_bard/hud/tft17_bard_square.tft_set17.png`,
  "Bel'Veth":         `${BASE}/tft17_belveth/hud/tft17_belveth_square.tft_set17.png`,
  "Blitzcrank":       `${BASE}/tft17_blitzcrank/hud/tft17_blitzcrank_square.tft_set17.png`,
  "Briar":            `${BASE}/tft17_briar/hud/tft17_briar_square.tft_set17.png`,
  "Caitlyn":          `${BASE}/tft17_caitlyn/hud/tft17_caitlyn_square.tft_set17.png`,
  "Cho'Gath":         `${BASE}/tft17_chogath/hud/tft17_chogath_square.tft_set17.png`,
  "Corki":            `${BASE}/tft17_corki/hud/tft17_corki_square.tft_set17.png`,
  "Diana":            `${BASE}/tft17_diana/hud/tft17_diana_square.tft_set17.png`,
  "Ezreal":           `${BASE}/tft17_ezreal/hud/tft17_ezreal_square.tft_set17.png`,
  "Fiora":            `${BASE}/tft17_fiora/hud/tft17_fiora_square.tft_set17.png`,
  "Fizz":             `${BASE}/tft17_fizz/hud/tft17_fizz_square.tft_set17.png`,
  "Gnar":             `${BASE}/tft17_gnar/hud/tft17_gnar_square.tft_set17.png`,
  "Gragas":           `${BASE}/tft17_gragas/hud/tft17_gragas_square.tft_set17.png`,
  "Graves":           `${BASE}/tft17_graves/hud/tft17_graves_square.tft_set17.png`,
  "Gwen":             `${BASE}/tft17_gwen/hud/tft17_gwen_square.tft_set17.png`,
  "Illaoi":           `${BASE}/tft17_illaoi/hud/tft17_illaoi_square.tft_set17.png`,
  "Jax":              `${BASE}/tft17_jax/hud/tft17_jax_square.tft_set17.png`,
  "Jhin":             `${BASE}/tft17_jhin/hud/tft17_jhin_square.tft_set17.png`,
  "Jinx":             `${BASE}/tft17_jinx/hud/tft17_jinx_square.tft_set17.png`,
  "Kai'Sa":           `${BASE}/tft17_kaisa/hud/tft17_kaisa_square.tft_set17.png`,
  "Karma":            `${BASE}/tft17_karma/hud/tft17_karma_square.tft_set17.png`,
  "Kindred":          `${BASE}/tft17_kindred/hud/tft17_kindred_square.tft_set17.png`,
  "LeBlanc":          `${BASE}/tft17_leblanc/hud/tft17_leblanc_square.tft_set17.png`,
  "Leona":            `${BASE}/tft17_leona/hud/tft17_leona_square.tft_set17.png`,
  "Lissandra":        `${BASE}/tft17_lissandra/hud/tft17_lissandra_square.tft_set17.png`,
  "Lulu":             `${BASE}/tft17_lulu/hud/tft17_lulu_square.tft_set17.png`,
  "Maokai":           `${BASE}/tft17_maokai/hud/tft17_maokai_square.tft_set17.png`,
  "Master Yi":        `${BASE}/tft17_masteryi/hud/tft17_masteryi_square.tft_set17.png`,
  "Meepsie":          `${BASE}/tft17_ivernminion/hud/tft17_ivernminion_square.tft_set17.png`,
  "Milio":            `${BASE}/tft17_milio/hud/tft17_milio_square.tft_set17.png`,
  "Miss Fortune":     `${BASE}/tft17_missfortune/hud/tft17_missfortune_square.tft_set17.png`,
  "Mordekaiser":      `${BASE}/tft17_mordekaiser/hud/tft17_mordekaiser_square.tft_set17.png`,
  "Morgana":          `${BASE}/tft17_morgana/hud/tft17_morgana_square.tft_set17.png`,
  "Nami":             `${BASE}/tft17_nami/hud/tft17_nami_square.tft_set17.png`,
  "Nasus":            `${BASE}/tft17_nasus/hud/tft17_nasus_square.tft_set17.png`,
  "Nunu & Willump":   `${BASE}/tft17_nunu/hud/tft17_nunu_square.tft_set17.png`,
  "Ornn":             `${BASE}/tft17_ornn/hud/tft17_ornn_square.tft_set17.png`,
  "Pantheon":         `${BASE}/tft17_pantheon/hud/tft17_pantheon_square.tft_set17.png`,
  "Poppy":            `${BASE}/tft17_poppy/hud/tft17_poppy_square.tft_set17.png`,
  "Pyke":             `${BASE}/tft17_pyke/hud/tft17_pyke_square.tft_set17.png`,
  "Rammus":           `${BASE}/tft17_rammus/hud/tft17_rammus_square.tft_set17.png`,
  "Rek'Sai":          `${BASE}/tft17_reksai/hud/tft17_reksai_square.tft_set17.png`,
  "Rhaast":           `${BASE}/tft17_rhaast/hud/tft17_kayn_slay_square.tft_set17.png`,
  "Riven":            `${BASE}/tft17_riven/hud/tft17_riven_square.tft_set17.png`,
  "Samira":           `${BASE}/tft17_samira/hud/tft17_samira_square.tft_set17.png`,
  "Shen":             `${BASE}/tft17_shen/hud/tft17_shen_square.tft_set17.png`,
  "Sona":             `${BASE}/tft17_sona/hud/tft17_sona_square.tft_set17.png`,
  "Tahm Kench":       `${BASE}/tft17_tahmkench/hud/tft17_tahmkench_square.tft_set17.png`,
  "Talon":            `${BASE}/tft17_talon/hud/tft17_talon_square.tft_set17.png`,
  "Teemo":            `${BASE}/tft17_teemo/hud/tft17_teemo_square.tft_set17.png`,
  "The Mighty Mech":  `${BASE}/tft17_galio/hud/tft17_galio_square.tft_set17.png`,
  "Twisted Fate":     `${BASE}/tft17_twistedfate/hud/tft17_twistedfate_square.tft_set17.png`,
  "Urgot":            `${BASE}/tft17_urgot/hud/tft17_urgot_square.tft_set17.png`,
  "Veigar":           `${BASE}/tft17_veigar/hud/tft17_veigar_square.tft_set17.png`,
  "Vex":              `${BASE}/tft17_vex/hud/tft17_vex_square.tft_set17.png`,
  "Viktor":           `${BASE}/tft17_viktor/hud/tft17_viktor_square.tft_set17.png`,
  "Xayah":            `${BASE}/tft17_xayah/hud/tft17_xayah_square.tft_set17.png`,
  "Zed":              `${BASE}/tft17_zed/hud/tft17_zed_square.tft_set17.png`,
  "Zoe":              `${BASE}/tft17_zoe/hud/tft17_zoe_square.tft_set17.png`,
}
